import React from 'react';
import { Box, Stack, Select, MenuItem, IconButton, Typography, FormControl } from '@mui/material';

import EditIcon from '../Icons/EditIcon';
import DeleteIcon from '../Icons/DeleteIcon';
import { useTranslation } from 'react-i18next';

export default function TicketShoppingCartSummary({
  origin,
  destination,
  departureDate,
  returnDate,
  travelType,
  total,
  ticketType,
  quantity,
  DiscountAmount,
  DiscountCaption,
  NonDiscountAmount,
  onRemove,
  onEdit,
}) {
  const { t } = useTranslation();
  return (
    <Stack gap="16px" padding="16px 0px" direction="column" borderBottom="1px solid rgba(0, 0, 0, 0.12)">
      <Stack direction="column">
        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="body1" color="secondary.light" fontWeight={700}>
            {t(origin)} - {t(destination)}
          </Typography>
          {DiscountCaption ? (
            <Typography
              color="#EF60A3"
              fontFamily="Gotham-Medium"
              backgroundColor="rgba(239, 96, 163, 0.1)"
              fontSize={'14px'}
              border={'1px solid #EF60A3'}
              borderRadius={'12px'}
              padding={'0.5em'}
            >
              {DiscountCaption}
            </Typography>
          ) : null}
          <Stack direction="row">
            {false && (
              <IconButton onClick={onEdit}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton onClick={onRemove}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>
        <Stack gap="8px" direction="row" alignItems="center">
          <Typography variant="caption" color="secondary.light">
            {departureDate}
            {returnDate ? ` - ${returnDate}` : ``}
          </Typography>
          <Box sx={{ width: 4, height: 4, borderRadius: '100%', bgcolor: '#EF60A3' }} />
          <Typography variant="caption" color="secondary.light">
            {travelType}
          </Typography>
        </Stack>
      </Stack>
      <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
        <FormControl sx={{ minWidth: 170 }} size="small">
          <Select value={ticketType}>
            <MenuItem value={ticketType}>{ticketType}</MenuItem>
          </Select>
        </FormControl>
        <Stack>
          <Typography fontSize={12} fontWeight={500} fontFamily="Gotham-Book" variant={DiscountAmount ? 'line-through' : 'none'}>
          ${NonDiscountAmount ? (quantity * NonDiscountAmount)?.toFixed?.(2) : total?.toFixed?.(2)} USD
          </Typography>
          {DiscountAmount ? (
            <Typography mt={0.5} fontSize={12} fontWeight={500}>
              ${total?.toFixed?.(2)} USD
            </Typography>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
}
